import Swal from 'sweetalert2/dist/sweetalert2.js'

export default new class {

  constructor () {
    this._title   = ''
    this._message = ''

    this._translator = {
      text: () => {
        return ''
      }
    }
  }

  /**
   *
   * @param confirmCallback
   * @param unConfirmCallback
   */
  init (confirmCallback, unConfirmCallback) {
    Swal
      .fire({
        icon:              'warning',
        title:             this._title,
        text:              this._message,
        showCancelButton:  true,
        cancelButtonText:  this._translator.text('cfm_No'),
        confirmButtonText: this._translator.text('cfm_Yes'),
        reverseButtons:    true
      })
      .then((result) => {
        if (result.value && result.value === true && confirmCallback) {
          confirmCallback()
          return
        }

        if (unConfirmCallback) {
          unConfirmCallback()
        }
      })
  }

  /**
   *
   * @param title
   */
  set title (title) {
    this._title = title
  }

  /**
   *
   * @param message
   */
  set message (message) {
    this._message = message
  }

  /**
   *
   * @param translator
   */
  set translator (translator) {
    this._translator = translator
  }

}
